import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Clock, Calendar, ExternalLink } from 'lucide-react';
import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';

const EventCard = ({ event }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const months = ['јануари', 'февруари', 'март', 'април', 'мај', 'јуни', 'јули', 'август', 'септември', 'октомври', 'ноември', 'декември'];
    return `${date.getDate()} ${months[date.getMonth()]} ${date.getFullYear()}`;
  };

  return (
    <Card className="overflow-hidden hover:shadow-lg transition-all duration-300 group">
      <div className="relative h-48 overflow-hidden">
        <img
          src={event.image}
          alt={event.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
        />
        <div className="absolute top-3 right-3">
          <Button
            size="sm"
            className="bg-blue-600 hover:bg-blue-700 shadow-lg"
            onClick={() => {
              if (event.status === 'upcoming') {
                window.location.href = event.registrationUrl;
              } else {
                window.location.href = `/events/${event.id}/contestants`;
              }
            }}
          >
            {event.status === 'upcoming' ? 'Пријави се' : 'Види стартна листа'}
          </Button>
        </div>
      </div>
      <CardContent className="p-5">
        <Link to={`/events/${event.id}`}>
          <h3 className="text-xl font-bold text-gray-900 mb-2 hover:text-blue-600 transition-colors">
            {event.title}
          </h3>
        </Link>
        {event.subtitle && (
          <p className="text-sm text-gray-600 italic mb-3">{event.subtitle}</p>
        )}
        <div className="space-y-2">
          <div className="flex items-start text-gray-700">
            <MapPin className="w-4 h-4 mr-2 mt-0.5 flex-shrink-0 text-gray-500" />
            <span className="text-sm">{event.location}</span>
          </div>
          <Link
            to={`/organizers/${event.organizerId}`}
            className="flex items-center text-gray-700 hover:text-blue-600 transition-colors group/link"
          >
            <ExternalLink className="w-4 h-4 mr-2 flex-shrink-0 text-gray-500 group-hover/link:text-blue-600" />
            <span className="text-sm">{event.organizer}</span>
          </Link>
          <div className="flex items-center justify-between pt-3 border-t border-gray-200 mt-3">
            <div className="flex items-center text-gray-700">
              <Clock className="w-4 h-4 mr-2 text-gray-500" />
              <span className="text-sm font-medium">{event.time}</span>
            </div>
            <div className="flex items-center text-gray-700">
              <Calendar className="w-4 h-4 mr-2 text-gray-500" />
              <span className="text-sm font-medium">{formatDate(event.date)}</span>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default EventCard;